import { useState } from 'react'
import { Blurhash } from 'react-blurhash'

const ProgressiveImage = ({
  src,
  blurHash,
  width,
  height,
  alt,
  radius,
}: {
  src: string | undefined
  width: number | string
  height: number | string
  blurHash: string | undefined
  alt: string
  radius?: number | string
}) => {
  const [isLoaded, setIsLoaded] = useState(false)

  return (
    <div
      style={{
        width,
        height,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: radius,
      }}
    >
      <img
        src={src}
        alt={alt}
        onLoad={() => setIsLoaded(true)}
        style={{
          width,
          height,
          position: 'absolute',
          inset: 0,
          objectFit: 'cover',
          objectPosition: 'center',
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity var(--dur-base) var(--ease-out)',
          zIndex: 2,
        }}
      />
      <div
        style={{
          width,
          height,
          position: 'absolute',
          inset: 0,
          opacity: isLoaded ? 0 : 1,
          zIndex: 1,
        }}
      >
        {blurHash && (
          <Blurhash
            hash={blurHash}
            width={width}
            height={height}
            resolutionX={32}
            resolutionY={32}
            punch={1}
          />
        )}
      </div>
    </div>
  )
}

export default ProgressiveImage
